/* istanbul ignore file */
import crmNoteValidation from 'domain/sales/shared/timeline/note/form/crmNoteValidation';
import { useBaseCrudService } from 'framework/crud';
import { useKernelApi } from 'infrastructure/api';

export const UPDATE_CRM_NOTE_PERMISSION = 'CREATE_NOTE';
export const DELETE_CRM_NOTE_PERMISSION = 'CREATE_NOTE';

const useCrmNoteService = () => {
  const { deleteById, update } = useBaseCrudService({
    listResourceUrl: '/crm/notes',
    singleResourceUrl: '/crm/notes/:id',
    useService: useKernelApi,
  });

  return {
    getValidationSchema: () => Promise.resolve(crmNoteValidation),
    deleteById,
    update,
  };
};

export default useCrmNoteService;
